import ActionManager from './ActionManager';
import { IInspectionTarget, InspectionTargetTypes } from '../interfaces/Misc';
import store, { StoreActions } from '../state/store';

export default abstract class Action
{
	static idCounter = 0;
	private readonly _id: number;

	private readonly _name: string;
	private _doParams?: any[];
	private _undoParams?: any[];
	private _isTemporary = false;
	protected _isDirtyAction;

	private previousInspectionTarget: IInspectionTarget = { type: InspectionTargetTypes.None, target: "" };

	private static generateActionId()
	{
		return Action.idCounter++;
	}

	protected constructor(doParams: any[], undoParams: any[], actionName: string | undefined = undefined, verifyParams: any[] = [], isDirtyAction: boolean = true)
	{
		this._isDirtyAction = isDirtyAction;
		this._id = Action.generateActionId();
		this._name = actionName !== undefined ? actionName : this.constructor.name;
		this._doParams = doParams;
		this._undoParams = undoParams;
		if (this.verify(...verifyParams))
		{
			this.beforeDo();
			this.do(...doParams);

			// TODO - this is bad. Adding this to the action stack should be done outside the constructor and probably explicitly by the caller
			// This works fine until you have a field that needs to be initialized in the subclass constructor
			// But it will not be initialized until the subclass constructor finishes, and thus will be initialized to undefined after this constructor finishes
			ActionManager.pushAction(this);
		}
	}

	get id(): number
	{
		return this._id;
	}
	get name(): string
	{
		return this._name;
	}

	get undoParams()
	{
		return this._undoParams;
	}

	get doParams()
	{
		return this._doParams;
	}

	get isTemporary(): boolean
	{
		return this._isTemporary;
	}

	get isDirtyAction(): boolean
	{
		return this._isDirtyAction;
	}

	beforeDo()
	{
		this.previousInspectionTarget = { ...store.getState().applicationModule.inspectionTarget };
	}

	do(...args: any[])
	{
		console.log("Empty Action.");
	}

	undo(...args: any[])
	{
		this.do(...args);
	}

	afterUndo()
	{
		store.dispatch(StoreActions.application.setInspectionTarget(this.previousInspectionTarget));
	}

	verify(...args: any[])
	{
		return true;
	}

	onDelete()
	{
		this.dispose();
		this._doParams = undefined;
		this._undoParams = undefined;
	}

	flagAsTemporary()
	{
		this._isTemporary = true;
	}

	getId()
	{
		return this._id;
	}

	dispose()
	{
	}
}
